import { render, staticRenderFns } from "./ErrorMessageArea.vue?vue&type=template&id=1b7c3690&scoped=true&"
import script from "./ErrorMessageArea.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageArea.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageArea.vue?vue&type=style&index=0&id=1b7c3690&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c3690",
  null
  
)

export default component.exports